import { j as r } from "./atoms-v218.js";
import { forwardRef as i } from "react";
import { Base as n, Header as f, Title as g, AddOnsColumn as p } from "./atoms-v21025.js";
import { Column as c } from "./atoms-v212.js";
import { AddOns as j } from "./atoms-v22.js";
import { useBreakpoints as u } from "./atoms-v251.js";
const L = i(
  ({ children: e, className: a, id: s, isSkeleton: m, skeletonCategoryCount: o, skeletonItemCount: l, title: t }, d) => {
    const { current: x } = u();
    return /* @__PURE__ */ r.jsxs(n, { className: a, id: s, ref: d, tagName: "article", children: [
      /* @__PURE__ */ r.jsx(f, { large: 8, offset: { xLarge: 1 }, xLarge: 14 }),
      /* @__PURE__ */ r.jsx(
        c,
        {
          large: 3,
          max: 5,
          medium: 8,
          offset: { xLarge: 1, max: 1 },
          small: 4,
          xLarge: 6,
          children: /* @__PURE__ */ r.jsx(g, { children: t })
        }
      ),
      /* @__PURE__ */ r.jsx(
        p,
        {
          large: 5,
          max: 8,
          medium: 8,
          offset: { xLarge: 1, max: 1 },
          small: 4,
          xLarge: 7,
          children: /* @__PURE__ */ r.jsx(
            j,
            {
              isSkeleton: m,
              skeletonCategoryCount: o,
              skeletonItemCount: l,
              variant: x === "small" ? "small" : "large",
              children: e
            }
          )
        }
      )
    ] });
  }
);
L.displayName = "Blocks.AddOns";
export {
  L as AddOns
};
